//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/mixins/global'
import axios, { CancelToken } from 'axios'

import Page07Sub from '../components/Page07Sub'

export default {
  components: {
    Page07Sub
  },

  data () {
    return {
      pagename: 'page07',
      tab: 'pcs',
      scrollTarget: 10,
      visible1: false,
      Refresh: true,
      viewclosed: 'N',
      date: '',
      curperiod: '',
      periods: [],
      customer: '',
      customers: [],
      brand: '',
      brands: [],
      status: 'ALL',
      viewstatus: 'Actual',
      ws: '',
      we: '',
      sono: '',
      loc: [],
      locs: ['G1', 'G2', 'G3', 'G4', 'GW', 'NYV1', 'TRM'],
      search1: {
        ws: '',
        we: ''
      }
    }
  },
  created () {
    this.CheckLocal()
    this.LoadFirst()

    // this.LoadPeriod()
  },
  async mounted () {
    this.LoadCustomer()
    this.LoadBrand()
    this.getlocarray()
    await new Promise(resolve => setTimeout(resolve, 1200))

    let a = await this.LoadPeriodDefault()
    let b = await this.LoadPeriod()
  },
  watch: {
    loc: function (newValue, oldValue) {},
    customer: function (newValue, oldValue) {},
    status: function (newValue, oldValue) {
      this.LoadPeriod()
    },
    viewstatus: function (newValue, oldValue) {}
  },
  computed: {},
  methods: {
    LoadFirst () {
      this.pulling = setTimeout(() => {
        this.chkAuthen('', '')
        this.pullData()
      }, 1000)
    },

    keeplocation () {
      // console.log(this.loc);
      const postjson = {
        authen: { keycode: this.$keycode },
        input: {
          uid: this.$store.getters.uid,
          syscode: this.$syscode,
          pagename: this.pagename,
          loc: this.loc
        }
      }

      axios({
        method: 'post',
        url: `${this.$apiflask}/log/keeplocarray`, // php
        data: postjson
      }).then(res => {
        this.LoadPeriod()
      })
    },

    getlocarray () {
      this.Refresh = false
      const postjson = {
        authen: { keycode: this.$keycode },
        input: {
          uid: this.$store.getters.uid,
          syscode: this.$syscode,
          pagename: this.pagename
        }
      }
      axios({
        method: 'post',
        url: `${this.$apiflask}/log/getlocarray`,
        data: postjson
      }).then(res => {
        if (res.data.length == 0) {
          this.loc = this.locs
        } else {
          this.loc = res.data
        }
      })
    },

    goPeriod () {
      this.pulling = setTimeout(() => {
        this.$refs.virtualListRef.scrollTo(14)
      }, 2000)
    },
    pullData () {
      this.pulling = setInterval(() => {
        var currentdate = new Date()
        if (
          currentdate.getMinutes() % 30 == 0 &&
          currentdate.getSeconds() == 0
        ) {
          this.LoadPeriod()
        }
        // console.log(currentdate)
      }, 1000)
    },

    async LoadCustomer () {
      this.Refresh = false
      const postjson = { authen: { keycode: this.$keycode } }
      await axios({
        method: 'post',
        url: `${this.$apiflask}/nygctroom/board7/customers`,
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.customers = res.data
        this.loading = false
      })
    },

    async LoadBrand () {
      this.Refresh = false
      const postjson = { authen: { keycode: this.$keycode } }
      await axios({
        method: 'post',
        url: `${this.$apiflask}/nygctroom/board7/brands`,
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.brands = res.data
        this.loading = false
      })
    },

    async LoadPeriodDefault () {
      const postjson = { authen: { keycode: this.$keycode } }
      await axios({
        method: 'post',
        url: `${this.$apiflask}/nygctroom/board7/defaultweek`,
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.ws = res.data.ps
        this.we = res.data.pe
        this.curperiod = res.data.pc
      })
    },

    LoadPeriod () {
      this.Refresh = false
      // console.log(this.periodType);
      const postjson = {
        authen: { keycode: this.$keycode },
        filter: {
          ps: this.ws,
          pe: this.we
        }
      }
      const obj = axios({
        method: 'post',
        url: `${this.$apiflask}/nygctroom/board7/period`,
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.periods = res.data
        this.Refresh = true
        this.goPeriod()
      })

      return obj
    },

    exportExcelSOSub () {
      debugger
      if (this.search1.ws == '' || this.search1.we == '') {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: 'Please fill Week!',
          html: true
        })
        return false
      } else {
        debugger
        window.open(
          `${this.$apiflask}nyg_ppr_planship/${this.search1.ws}/${
            this.search1.we
          }?uuid=${this.create_UUID()}`,
          '_export'
        )
      }
    },

    getClassSize () {
      if (this.$q.screen.width <= 1440) {
        return 'text-h4 fnt'
      } else {
        return 'text-h3 fnt'
      }
    },
    getClassSize2 () {
      if (this.$q.screen.width <= 1440) {
        return 'text-h5 fnt'
      } else {
        return 'text-h4 fnt'
      }
    }
    // goPeriod() {
    //   var elmnt = document.getElementById("WK-202030");
    //   elmnt.scrollIntoView();
    // }
  }
}
